import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { ArrowRight, Loader2 } from "lucide-react";

const API = `/api`;
console.log(API)
const FIELDS = [
  { name: "name", label: "Your Name", type: "text", required: true },
  { name: "company", label: "Company / Venue", type: "text", required: false },
  { name: "email", label: "Email", type: "email", required: true },
  { name: "phone", label: "Phone", type: "tel", required: false },
];

export const EnquiryForm = () => {
  const [form, setForm] = useState({ name: "", company: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      toast.error("Please add your name, email and a short message.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/enquiries`, form);
      toast.success("Enquiry sent — we'll be in touch shortly.");
      setForm({ name: "", company: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="enquire" data-testid="enquire-section" className="relative py-20 md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
        <Reveal className="md:col-span-5">
          <p className="text-xs tracking-[0.3em] uppercase font-medium text-[#B07D4E] mb-5">Request Samples</p>
          <h2 className="font-display text-5xl sm:text-6xl md:text-7xl tracking-tight leading-[0.92] text-[#2A221C]">
            Let&apos;s build<br /><span className="italic text-[#D4A373]">your menu.</span>
          </h2>
          <p className="mt-8 font-light text-[#2A221C]/70 leading-relaxed max-w-sm">
            Tell us about your venue and we&apos;ll send a tasting box and wholesale pricing
            tailored to your service.
          </p>
        </Reveal>

        <Reveal delay={0.15} className="md:col-span-7">
          <form onSubmit={submit} data-testid="enquiry-form" className="space-y-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              {FIELDS.map((f) => (
                <div key={f.name} className="relative">
                  <label className="block text-[10px] tracking-[0.25em] uppercase text-[#2A221C]/50 mb-2">
                    {f.label}{f.required && " *"}
                  </label>
                  <input
                    data-testid={`enquiry-${f.name}`}
                    type={f.type}
                    value={form[f.name]}
                    onChange={update(f.name)}
                    className="w-full bg-transparent border-b border-[#2A221C]/25 py-2 text-lg text-[#2A221C] outline-none focus:border-[#D4A373] transition-colors placeholder:text-[#2A221C]/30"
                    placeholder="—"
                  />
                </div>
              ))}
            </div>

            <div>
              <label className="block text-[10px] tracking-[0.25em] uppercase text-[#2A221C]/50 mb-2">
                What are you looking for? *
              </label>
              <textarea
                data-testid="enquiry-message"
                value={form.message}
                onChange={update("message")}
                rows={3}
                className="w-full bg-transparent border-b border-[#2A221C]/25 py-2 text-lg text-[#2A221C] outline-none focus:border-[#D4A373] transition-colors resize-none placeholder:text-[#2A221C]/30"
                placeholder="Ranges, volumes, launch dates…"
              />
            </div>

            <motion.button
              data-testid="enquiry-submit"
              type="submit"
              disabled={loading}
              whileHover={{ scale: 1.01 }}
              whileTap={{ scale: 0.99 }}
              className="group inline-flex items-center gap-4 bg-[#2A221C] text-[#FDFBF7] px-8 py-4 text-xs tracking-[0.2em] uppercase font-medium disabled:opacity-60"
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />}
              {loading ? "Sending" : "Send Enquiry"}
            </motion.button>
          </form>
        </Reveal>
      </div>
    </section>
  );
};
